import genericCollectionUtils from '@nhl/generic-collection-utils';

const selectedTeamsReducerFactory =
        (...changeTeamActionTypes) =>
        (...changeDivisionActionTypes) =>
        (...changeConferenceActionTypes) =>
        (...changeAllActionTypes) =>
        (...selectIndividualTeamActionTypes) =>
        (...replaceTeamsActionTypes) =>

    (state = [], action) => {
            const { payload } = action || {};

            if (changeTeamActionTypes.includes(action.type)) {
                return genericCollectionUtils.performAddOrRemoveSelection([...state], payload.teamId,
                    payload.availableTeams, payload.isChecked);
            } else if (changeDivisionActionTypes.includes(action.type)) {
                return toggleDivision([...state], payload.divisionId, payload.availableTeams, payload.isChecked);
            } else if (changeConferenceActionTypes.includes(action.type)) {
                return toggleConference([...state], payload.conferenceId, payload.availableTeams, payload.isChecked);
            } else if (changeAllActionTypes.includes(action.type)) {
                return toggleAll([...state], payload.id, payload.availableTeams, payload.isChecked);
            } else if (selectIndividualTeamActionTypes.includes(action.type)) {
                return toggleToIndividualTeam(payload.availableTeams, payload.id);
            } else if (replaceTeamsActionTypes.includes(action.type)) {
                return payload.selectedTeams || [];
            }

    return state;
};

const toggleDivision = (selectedTeams, divisionId, teams, isChecked) => {
    if (isChecked) {
        return selectedTeams.concat(teams.filter(
            team => {
                // This check is here for when we have a new team, which has a division, but has not been given a TeamStats
                // row yet (e.g. VGK circa 2016)
                const teamDivisionId = team.stats ? team.stats.division.id : team.division.id;

                return teamDivisionId === divisionId && !selectedTeams.includes(team)
            }));
    } else {
        return selectedTeams.filter(team => {
            const teamDivisionId = team.stats ? team.stats.division.id : team.division.id;

            return teamDivisionId !== divisionId;
        });
    }
};

const toggleConference = (selectedTeams, conferenceId, teams, isChecked) => {
    if (isChecked) {
        return selectedTeams.concat(teams.filter(
            team => {
                // This check is here for when we have a new team, which has a division, but has not been given a TeamStats row yet (e.g. VGK circa 2016)
                const teamConferenceId = team.stats ? team.stats.conference.id : team.conference.id;

                return teamConferenceId === conferenceId && !selectedTeams.includes(team);
            }));
    } else {
        return selectedTeams.filter(team => {
            const teamConferenceId = team.stats ? team.stats.conference.id : team.conference.id;

            return teamConferenceId !== conferenceId;
        });
    }
};

const toggleAll = (selectedTeams, id, teams, isChecked) => {
    if (isChecked) {
        return selectedTeams.concat(teams.filter(team => !selectedTeams.includes(team)));
    } else {
        return selectedTeams = [];
    }
};

const toggleToIndividualTeam = (selectedTeams, id) => {
    return selectedTeams.filter(team => team.id === id);
};

export default {
    selectedTeamsReducerFactory
};